import { gql } from "@apollo/client";

export const DESESTIMAR_RECLAMO = gql`
    mutation desestimarReclamo($idGestionReclamo: Int!, $justificacion: String!){
        desestimarReclamo(idGestionReclamo: $idGestionReclamo, justificacion: $justificacion) {
            idGestionReclamo
        }
    }
`;